import React from 'react';
import { useParams } from 'react-router-dom';
import { NodeToolbar } from 'Custom-Mindmap';
import { MindMapContext } from '../../Context/contex';
import useMindMapService from '../../hooks/useMindMapService';
import { emitNodeUpdate } from '../../Socket/socket';
import { PALETTE_COLORS, TRANSPARENT_COLOR } from '../Shapes/shapeCatalog';
import './colorPalette.css';

// Space (px) between the shape and the palette, leaving room for the top "+" button.
const PALETTE_OFFSET = 40;

const stopPropagation = (event) => event.stopPropagation();

// Colour swatches above the selected shape (D-033). A pick is saved like the Edit drawer saves a colour.
const ColorPalette = ({ nodeId, data, type }) => {
    const { documentId } = useParams();
    const { isReadOnly, nodes, edges, setNodes, setIsDocumentChanged, recordChange } = MindMapContext();
    const mindMapService = useMindMapService();
    if (isReadOnly) return null;

    const chooseColor = (event, color) => {
        event.stopPropagation();
        const updatedNodes = nodes.map((node) =>
            node.id === nodeId
                ? { ...node, data: { ...node.data, nodeBg: color }, style: { ...node.style, backgroundColor: color } }
                : node
        );
        setNodes(updatedNodes);
        recordChange({ nodes, edges }, { nodes: updatedNodes, edges });
        emitNodeUpdate({ id: nodeId, bg: color, documentId });
        mindMapService.updateNode(
            nodeId,
            { data: { label: data.label, nodeBg: color, textBg: data.textBg }, type },
            { nodes: updatedNodes, edges }
        );
        setIsDocumentChanged(true);
    };

    return (
        <NodeToolbar nodeId={nodeId} offset={PALETTE_OFFSET} className="color-palette">
            {PALETTE_COLORS.map((color) => (
                <button
                    key={color}
                    type="button"
                    title={color === TRANSPARENT_COLOR ? 'Transparent' : color}
                    aria-label={color === TRANSPARENT_COLOR ? 'No fill' : `Colour ${color}`}
                    aria-pressed={data.nodeBg === color}
                    className={`color-swatch ${color === TRANSPARENT_COLOR ? 'transparent' : ''} ${data.nodeBg === color ? 'active' : ''}`}
                    style={color === TRANSPARENT_COLOR ? undefined : { backgroundColor: color }}
                    onClick={(event) => chooseColor(event, color)}
                    onDoubleClick={stopPropagation}
                />
            ))}
        </NodeToolbar>
    );
};

export default ColorPalette;
